<fz-main-layout>
  <div class="main-view">
    <!-- Toolbar -->
    <fz-navbar
      [sticky]="100"
      variant="permanent"
      [theme]="colorScheme"
      [enableSwitchTheme]="true"
    ></fz-navbar>

    <!-- Breadcrumb -->
    <fz-breadcrumbs></fz-breadcrumbs>

    <div>
      <ng-content select="fz-static-view"></ng-content>
      <router-outlet></router-outlet>
    </div>
  </div>
</fz-main-layout>
